export const ALERTS_COUNT_QUERY = `
  query AlertsCountQuery {
    me {
      newNotificationsCount(type: ALERTS_ONLY)
    }
  }
`;
